export default __webpack_public_path__ + "static/media/talented.61d07234.svg";